// extracted by mini-css-extract-plugin
export default {"carousel-container":"Carousel_carousel-container__axzcd","banner":"Carousel_banner__kxInP"};